import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const inventarioImporterSelectors = importerSelectors(
  'inventario.importer',
);

export default inventarioImporterSelectors;
